const GSEARCH_CONFIG = {
    googleApiKey: "AIzaSyBmpP8Iv2my55vZJXGRvwwplm15878ST54",
    googleSearchEngineId: "c5240984792544179",
    domains: ["informaticos.ar", "formacion.informaticos.ar"],
    iconSize: "16px",
    iconColor: "#333333",
    position: { top: "16px", right: "22px" }
};
